import { render } from "./PermissionDenied.vue?vue&type=template&id=22d25152&scoped=true"
import script from "./PermissionDenied.vue?vue&type=script&lang=js"
export * from "./PermissionDenied.vue?vue&type=script&lang=js"

import "./PermissionDenied.vue?vue&type=style&index=0&id=22d25152&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d25152"]])

export default __exports__